import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { LanguageProvider } from "./context/LanguageContext";
import { CartProvider } from "./context/CartContext";
import { Toaster } from "./components/ui/sonner";
import ProtectedRoute from "./components/ProtectedRoute";

// Pages
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Restaurants from "./pages/Restaurants";
import RestaurantDetail from "./pages/RestaurantDetail";
import Analytics from "./pages/Analytics";
import PublicMenu from "./pages/PublicMenu";
import DishDetail from "./pages/DishDetail";
import CartPage from "./pages/CartPage";
import OrderSummary from "./pages/OrderSummary";
import SetupWizard from "./pages/SetupWizard";
import QRPoster from "./pages/QRPoster";
import ShopAdmins from "./pages/ShopAdmins";
import LiveOrders from "./pages/LiveOrders";
import PerfumeDashboard from "./pages/PerfumeDashboard";
import PerfumeShops from "./pages/PerfumeShops";
import PerfumeShopDetail from "./pages/PerfumeShopDetail";
import PerfumeCatalog from "./pages/PerfumeCatalog";
import PerfumeDetailPage from "./pages/PerfumeDetailPage";
import PerfumeCheckout from "./pages/PerfumeCheckout";

import OrderTracking from "./pages/OrderTracking";

function App() {
  return (
    <AuthProvider>
      <LanguageProvider>
      <CartProvider>
      <BrowserRouter>
        <Routes>
          {/* Public Routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/menu/:slug" element={<PublicMenu />} />
          <Route path="/menu/:slug/dish/:dishId" element={<DishDetail />} />
          <Route path="/menu/:slug/cart" element={<CartPage />} />
          <Route path="/menu/:slug/order" element={<OrderSummary />} />
          <Route path="/track/:orderId" element={<OrderTracking />} />

          {/* Public Perfume Catalog Routes */}
          <Route path="/catalog/:slug" element={<PerfumeCatalog />} />
          <Route path="/catalog/:slug/perfume/:perfumeId" element={<PerfumeDetailPage />} />
          <Route path="/catalog/:slug/checkout" element={<PerfumeCheckout />} />

          {/* Protected Routes */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard/restaurants"
            element={
              <ProtectedRoute>
                <Restaurants />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard/restaurants/:id"
            element={
              <ProtectedRoute>
                <RestaurantDetail />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard/restaurants/:id/qr-poster"
            element={
              <ProtectedRoute>
                <QRPoster />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard/analytics"
            element={
              <ProtectedRoute>
                <Analytics />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard/shop-admins"
            element={
              <ProtectedRoute>
                <ShopAdmins />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard/live-orders/:restaurantId"
            element={
              <ProtectedRoute>
                <LiveOrders />
              </ProtectedRoute>
            }
          />
          {/* Public live orders via secret key */}
          <Route path="/live/:restaurantId" element={<LiveOrders />} />

          {/* Perfume Routes */}
          <Route path="/dashboard/perfume" element={<ProtectedRoute><PerfumeDashboard /></ProtectedRoute>} />
          <Route path="/dashboard/perfume/shops" element={<ProtectedRoute><PerfumeShops /></ProtectedRoute>} />
          <Route path="/dashboard/perfume/shops/:id" element={<ProtectedRoute><PerfumeShopDetail /></ProtectedRoute>} />

          <Route
            path="/setup"
            element={
              <ProtectedRoute>
                <SetupWizard />
              </ProtectedRoute>
            }
          />

          {/* Redirects */}
          <Route path="/" element={<Navigate to="/login" replace />} />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </BrowserRouter>
      </CartProvider>
      </LanguageProvider>
      <Toaster richColors position="top-right" />
    </AuthProvider>
  );
}

export default App;
